import AdminList from './AdminList'
import AdminCreate from './AdminCreate'
import AdminEdit from './AdminEdit'

export default { list: AdminList, create: AdminCreate, edit: AdminEdit }
